import { render } from "./MainPageSlider.vue?vue&type=template&id=3b0ee43c&scoped=true"
import script from "./MainPageSlider.vue?vue&type=script&lang=js"
export * from "./MainPageSlider.vue?vue&type=script&lang=js"

import "./MainPageSlider.vue?vue&type=style&index=0&id=3b0ee43c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0ee43c"]])

export default __exports__